import React from 'react'

import { List, ListItem, ListItemText, Typography, Paper } from '@mui/material'
import { useTheme } from '@mui/styles'
import { useTranslation } from 'react-i18next'

import NoData from '~/components/NoData'
const Notes = ({ data, title }) => {
  const { t } = useTranslation('mkt')
  const theme = useTheme()

  const renderTitle = () => {
    if (title === '') return null

    return (
      <Typography variant="h4" sx={{ mb: 1 }}>
        {title}
      </Typography>
    )
  }
  return (
    <Paper
      sx={{
        p: 1,
      }}
    >
      {renderTitle()}

      {!data.length ? (
        <NoData text={t('dataTable.noData')} />
      ) : (
        <List sx={{ p: 0 }}>
          {(data || []).map((item, index) => (
            <ListItem
              alignItems="flex-start"
              key={index}
              disableGutters
              disablePadding
            >
              <ListItemText color={theme.palette.text.main}>
                {item.note}
              </ListItemText>
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  )
}

Notes.defaultProps = {
  data: [],
  title: '',
}

export default Notes
